import $ from 'cash-dom'

const data = {
  from: {},
  to: {}
}

const replicateElements = {
  replicate (fromEl, toEl) {
    // cleanup toEl
    $(toEl).children(':not(.teleport)').remove()

    for (let i = 0; i < fromEl.childNodes.length; i++) {
      const child = fromEl.childNodes[i]
      const childTag = child.tagName ? child.tagName.toLowerCase() : 'text'
      const cloned = child.cloneNode(true)
      if ((childTag === 'input' || childTag === 'button') && child.type.toLowerCase() === 'submit') {
        cloned.onclick = (e) => {
          e.preventDefault()
          e.stopPropagation()
          child.click()
          return false
        }
      }

      if (childTag === 'text' || (!child.classList.contains('d-none') && !child.classList.contains('nod') && !child.classList.contains('hidden'))) {
        toEl.appendChild(cloned)
      }
    }
  }
}

export default {
  mounted (el, binding) {
    let key
    if (binding.value.to) {
      key = binding.value.to
      data.from[binding.value.to] = el
    } else {
      key = binding.value.from
      data.to[binding.value.from] = el
    }

    if (data.from[key] && data.to[key]) {
      replicateElements.replicate(data.from[key], data.to[key])
    }
  },

  updated (el, binding) {
    let key
    if (binding.value.to) {
      key = binding.value.to
      data.from[binding.value.to] = el
    } else {
      key = binding.value.from
      data.to[binding.value.from] = el
    }

    if (data.from[key] && data.to[key]) {
      replicateElements.replicate(data.from[key], data.to[key])
    }
  }
}
